import React from 'react';
import Error from './Error';

const NotFound = () =>
    <Error errorType={'notFound'} />

export default NotFound;